import { memo } from 'react';

import { CircleSlashIcon } from '@air/design-icons';
import { Chip } from '@air/primitive-chip';

import { formatDuration } from './formatDuration';

type ModelCostBadgeProps = {
  credits?: number;
  durationMs?: number;
};

export const ModelCostBadge = memo(({ credits, durationMs }: ModelCostBadgeProps) => (
  <Chip className="gap-px" color="gray" shape="rectangular" size="small">
    {credits !== undefined && (
      <span className="inline-flex items-center gap-1">
        <CircleSlashIcon className="shrink-0" size="sm" />
        {credits}
      </span>
    )}
    {credits !== undefined && durationMs !== undefined && (
      <span className="ads:text-metadata text-gray-9">&nbsp;&middot;&nbsp;</span>
    )}
    {durationMs !== undefined && formatDuration(durationMs)}
  </Chip>
));

ModelCostBadge.displayName = 'ModelCostBadge';
